<script lang="ts">
  import { browser } from "$app/environment";

  import { fly } from "svelte/transition";

  import LoginSignupButtons from "$lib/design-systems/marketing/patterns/LoginSignupButtons.svelte";
  import { user } from "$lib/identity/user";
  import MobileMenuSubDropdown from "./MobileMenuSubDropdown.svelte";

  type Link = { href: string; name: string };
  type LinkGroup = { hrefRoot: string; name: string; links: Link[] };

  type Props = {
    open?: boolean;
    links?: Array<Link | LinkGroup>;
    paddingTop: string;
  };

  let { open = $bindable(false), links = [], paddingTop }: Props = $props();

  function closeDropdowns() {
    open = false;
  }

  // Lock body scroll while the overlay is open; the cleanup also runs on
  // destroy so a navigation away never leaves the page unscrollable.
  $effect(() => {
    if (!browser || !open) return;
    document.body.classList.add("overflow-hidden", "md:overflow-auto");
    return () => {
      document.body.classList.remove("overflow-hidden", "md:overflow-auto");
    };
  });
</script>

<div
  class="fixed inset-0 -z-10 flex h-full flex-col overflow-y-auto bg-ground opacity-0 backdrop-blur-xl md:hidden"
  class:opacity-100={open}
  class:pointer-events-none={!open}
  style:padding-top={paddingTop}
  style:transition={`opacity ${50 * (links.length + 1)}ms linear`}
>
  {#if open}
    <div
      class="flex gap-2 border-b border-divider px-9 py-4"
      transition:fly={{ y: -15, delay: 0 }}
    >
      <LoginSignupButtons
        loggedIn={$user?.loggedIn ?? false}
        login="button"
        size="md"
        class="flex-1"
      />
    </div>
  {/if}
  {#each open ? links : [] as link, i (link.name)}
    {#if "href" in link}
      <a
        class="border-b border-divider px-9 py-4 text-lg text-primary capitalize transition-colors hover:text-accent-hover"
        href={link.href}
        onclick={closeDropdowns}
        transition:fly={{ y: -15, delay: 50 * (i + 1) }}
      >
        {link.name}
      </a>
    {:else}
      <MobileMenuSubDropdown
        group={link}
        onLinkClick={closeDropdowns}
        flyDelay={50 * (i + 1)}
      />
    {/if}
  {/each}
</div>
